import { DarkTheme, LightTheme } from "styled-components";
import {
    Black,
    DarkTeal,
    DiscordBlue,
    Gold,
    Teal,
    White,
} from "./ColorPallete";
import BlackDiscordIcon from "../Icons/blackDiscordIcon.png";
import WhiteDiscordIcon from "../Icons/whiteDiscordIcon.png";
import BlackMetricsIcon from "../Icons/blackStatsIcon.png";
import WhiteMetricsIcon from "../Icons/whiteStatsIicon.png";

const darkCardGradientStart = "#1E1E1E";
const darkCardGradient = `linear-gradient(120deg, #1E1E1E 0%, ${Black} 100%)`;
const lightCardGradient = `linear-gradient(120deg, #fff 0%, ${White} 100%)`;

const fontSizes = {
    small: 14,
    medium: 26,
    large: 35,
};

const lightTheme: LightTheme = {
    colors: {
        text: Black,
        background: White,
        backgroundOpposite: Black,
        borderAccent: DarkTeal,
        iconAccent: Gold,
        textAccent: Teal,
        discordBlue: DiscordBlue,
        cardText: Black,
        cardGradient: lightCardGradient,
        cardGradientStart: darkCardGradientStart,
    },
    icons: {
        discord: BlackDiscordIcon,
        metrics: BlackMetricsIcon,
    },
    fontSize: fontSizes,
    animationTime: {
        short: 0.5,
        medium: 1,
        long: 3,
    },
    breakpoint: 1200,
};

const darkTheme: DarkTheme = {
    colors: {
        text: White,
        background: Black,
        backgroundOpposite: White,
        borderAccent: DarkTeal,
        iconAccent: Gold,
        textAccent: Teal,
        discordBlue: DiscordBlue,
        cardText: White,
        cardGradient: darkCardGradient,
        cardGradientStart: darkCardGradientStart,
    },
    icons: {
        discord: WhiteDiscordIcon,
        metrics: WhiteMetricsIcon,
    },
    fontSize: fontSizes,
    animationTime: {
        short: 0.5,
        medium: 1,
        long: 3,
    },
    breakpoint: 1200,
};

export { lightTheme, darkTheme };
